export default {
  actions: {
    setCurrent(context, accountId) {
      return this.dispatch('account/get', accountId).then((account) => {
        context.commit("setCurrent", accountId)
      })
    }
  }
}